import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center mb-5" }
const _hoisted_2 = { class: "text-2xl font-semibold" }
const _hoisted_3 = { class: "flex gap-4" }

import { ref } from "vue";

import {
  defineComponent,
  defineProps,
  defineEmits,
  onMounted,
  watch,
} from "vue";

const __default__ = defineComponent({
  name: "LbrxLogoutModal",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "logout"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(props.open);

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue;
  }
);

watch(isOpen, (newValue) => {
  emit("update:open", newValue);

});

const closeModal=()=>{
  isOpen.value = false;
}

const logout = () => {
  emit('logout');
}

const backgroundColor = ref("");

onMounted(() => {
  const bgColor = localStorage.getItem("themeTemplate");

  if (bgColor) {
    backgroundColor.value = JSON.parse(bgColor).primaryColor;
  } else {
    backgroundColor.value = "#fc8019";
  }
});

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    width: "600px",
    centered: "",
    open: isOpen.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    closable: false
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("Pos.logoutTxt")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "flex w-full rounded-md py-2 text-lg items-center justify-center text-white",
          style: _normalizeStyle({ backgroundColor: backgroundColor.value }),
          onClick: logout
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Pos.Logout")), 1)
        ], 4),
        _createElementVNode("button", {
          class: "flex w-full rounded-md py-2 text-lg items-center justify-center border",
          style: _normalizeStyle({
          color: backgroundColor.value,
          backgroundColor: '#fff',
          borderColor: backgroundColor.value,
        }),
          onClick: closeModal
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Pos.Cancel")), 1)
        ], 4)
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})